import * as React from 'react';
import { DocumentHead } from 'lib/components';
import { UnsubscribeContent } from './components';
import { useTranslation } from 'react-i18next';

export const Unsubscribe = () => {
  const { t } = useTranslation();

  return (
    <>
      <DocumentHead title={t('Unsubscribe')} />
      <UnsubscribeContent />
    </>
  );
};
